export default __webpack_public_path__ + "static/media/logo-icon.6b314f91.svg";